import { render, staticRenderFns } from "./msBangDing.vue?vue&type=template&id=1045207a&scoped=true"
import script from "./msBangDing.vue?vue&type=script&lang=js"
export * from "./msBangDing.vue?vue&type=script&lang=js"
import style0 from "./msBangDing.vue?vue&type=style&index=0&id=1045207a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1045207a",
  null
  
)

export default component.exports